import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBaseService } from '@gea-waldviertler-website/shop-lib';
import { CategoryPageContentResponseInterface, CategoryResponseInterface } from "@gea-waldviertler-website/gea-models";

@Injectable()
export class HttpCategoryService extends HttpBaseService {

  getCategories(withRoot: boolean, parent?: string) : Observable<CategoryResponseInterface[]> {
    let url: string = this.getMainApiBaseUrl() + `/category/list?withRoot=${withRoot}` + (parent ? "&parent=" + parent : '')
    return this.http.get<CategoryResponseInterface[]>(url)
  }

  getPageContents(slug: string) : Observable<CategoryPageContentResponseInterface> {
    if(! slug.startsWith("/")) {
      slug = "/" + slug
    }

    let url: string = this.getMainApiBaseUrl() + `/product/all?categorySlug=${slug}`
    return this.http.get<CategoryPageContentResponseInterface>(url)
  }
}
